export const eduList = [
  // 工作台
  {
    menuId: '647389766177800192',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '工作台',
    menuUrl: 'mainCenter',
    menuIcon: '647389653497806849',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      {
        menuId: '6473904716245435432955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '数据概览',
        menuUrl: 'education',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509453454394273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 运营端 - 数据概览
          {
            menuId: '6473904716254342955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '数据看板',
            menuUrl: 'mainCenter_education_educationIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 运营端 - 数据概览
          {
            menuId: '64739047162454355432955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '报名数据统计',
            menuUrl: 'mainCenter_education_eduRegistrationDataStatistics',
            menuIcon: '647390423244865345435536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '554354353453464765',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }, // 运营端 - 数据概览
          {
            menuId: '64739047162454352345432955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '财务数据统计',
            menuUrl: 'mainCenter_education_eduCourseIncomeDataStatistics',
            menuIcon: '6473904232453442354865345435536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '5543543534543553464765',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 课程中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '课程中心',
    menuUrl: 'courseCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 课程中心 - 商品管理
      {
        menuId: '64739047164955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '商品管理',
        menuUrl: 'commodity',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 商品管理 - 课程商品
          {
            menuId: '64739047142955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程商品',
            menuUrl: 'courseCenter_commodity_commodityTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 商品管理-材料管理
          {
            menuId: '64739047142955793',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '材料管理',
            menuUrl: 'courseCenter_commodity_materialTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 2,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 课程中心 - 资源管理
      {
        menuId: '1647390471642955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '资源管理',
        menuUrl: 'resources',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 资源管理 - 课程资源
          {
            menuId: '64730471642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程资源',
            menuUrl: 'courseCenter_resources_courseTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 课程中心 - 课程设置
      {
        menuId: '64739047164295577',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '课程设置',
        menuUrl: 'courseSetting',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 课程设置 - 分类管理
          {
            menuId: '6473971642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '分类管理',
            menuUrl: 'courseCenter_courseSettings_courseClassify',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }

    ]
  },
  // 排课中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '排课中心',
    menuUrl: 'courseSchedulCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 排课管理
      {
        menuId: '647SDSdasdsada955778',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '排课管理',
        menuUrl: 'courseSchedulManage',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 排课管理
          {
            menuId: '6473932dasdas0471645778',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '排课管理',
            menuUrl:
              'courseSchedulCenter_courseSchedulManage_courseSchedulList',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 分班管理
      {
        menuId: '647SDS955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '分班管理',
        menuUrl: 'divideClassManage',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 分班管理 - 分班管理
          {
            menuId: '647393idsdfg77',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '分班管理',
            menuUrl: 'courseSchedulCenter_divideClassManage_list',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }

        ]
      },
      // 分班查询
      {
        menuId: '647390473242955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '分班查询',
        menuUrl: 'divideClassSearch',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 分班查询 - 按学生查询
          {
            menuId: '647390471955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '按学生查询',
            menuUrl: 'courseSchedulCenter_divideClassSearch_searchList',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班管理 - 待分班学生
          {
            menuId: '6473932320471645777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '待分班学生',
            menuUrl:
              'courseSchedulCenter_divideClassSearch_divideIntoClassStudents',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 分班课表
      {
        menuId: '6473904742955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '分班课表',
        menuUrl: 'divideClassTimeTable',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 分班课表 - 教师课表
          {
            menuId: '6490471642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师课表',
            menuUrl:
              'courseSchedulCenter_divideClassTimeTable_teacherTimeTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班课表 - 学生课表
          {
            menuId: '6473904716429557314',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学生课表',
            menuUrl:
              'courseSchedulCenter_divideClassTimeTable_studentTimeTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班课表 - 学校课表
          {
            menuId: '647390471642355777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学校课表',
            menuUrl: 'courseSchedulCenter_divideClassTimeTable_schoolTimeTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 班级课表（走向表）
          {
            menuId: '647390471642355771',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '班级课表(走向表)',
            menuUrl:
              'courseSchedulCenter_divideClassTimeTable_ClassTimeTableGo',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 订单中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '订单中心',
    menuUrl: 'orderCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 订单管理 - 订单管理
      {
        menuId: 'DSD971642955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '订单管理',
        menuUrl: 'order',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '647347164A7',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程订单',
            menuUrl: 'orderCenter_order_orderTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '6473471642C',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程套餐订单',
            menuUrl: 'orderCenter_order_comboIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },

          {
            menuId: '6473471643A',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '材料费订单',
            menuUrl: 'orderCenter_order_materialIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 订单管理 - 售后管理
      {
        menuId: 'DSD9S5777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '售后管理',
        menuUrl: 'afterSale',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '退款管理',
            menuUrl: 'orderCenter_afterSale_schCourseRefund',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
      // {
      //   menuId: 'DSD9S5778',
      //   domainCode: 'zhxy-cloud',
      //   appCode: 'basic430hon',
      //   typeCode: '$default',
      //   menuName: '财务管理',
      //   menuUrl: 'finance',
      //   menuIcon: '647390423244865536',
      //   openWay: 1,
      //   accessFlag: 1,
      //   parentMenuId: '647390246509494273',
      //   sort: 1,
      //   status: null,
      //   extra: '',
      //   childList: [
      //     {
      //       menuId: '6dada473471642R',
      //       domainCode: 'zhxy-cloud',
      //       appCode: 'basic430hon',
      //       typeCode: '$default',
      //       menuName: '结算账单（教育局）',
      //       menuUrl: 'orderCenter_finance_EduSettlement',
      //       menuIcon: '647390423244865536',
      //       openWay: 1,
      //       accessFlag: 1,
      //       parentMenuId: 'DSD9S5778',
      //       sort: 1,
      //       status: null,
      //       extra: '',
      //       childList: []
      //     }
      //   ]
      // }
    ]
  },
  // 财务中心
  {
    menuId: '658618431720919150',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '财务中心',
    menuUrl: 'financeCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 订单管理 - 订单管理
      {
        menuId: 'FSD971642955888',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '结算单管理',
        menuUrl: 'settlement',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '45876897698A',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '结算账单（教育局）',
            menuUrl: 'financeCenter_settlement_edu',
            menuIcon: '5135415431',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '52364356426',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 教务中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '教务中心',
    menuUrl: 'eduCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 教务中心 - 教师考勤
      {
        menuId: '33331d',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '教师考勤',
        menuUrl: 'schoolAttendance',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '3343254354554651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤明细',
            menuUrl: 'eduCenter_schoolAttendance_index',
            menuIcon: '425436548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '33331d',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '33432543532424554651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤汇总(按月)',
            menuUrl: 'eduCenter_schoolAttendance_collectedu',
            menuIcon: '425436548789985434345',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '33331d',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 消息管理 - 公共
      {
        menuId: '647390432423446429777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '消息管理',
        menuUrl: 'message',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6473904sdasd6429777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '消息管理',
            menuUrl: 'eduCenter_message_list',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
          // {
          //   menuId: '6sdd739046429777',
          //   domainCode: 'zhxy-cloud',
          //   appCode: 'basic430hon',
          //   typeCode: '$default',
          //   menuName: '待办审批',
          //   menuUrl: 'eduCenter_message_pending',
          //   menuIcon: '647390423244865536',
          //   openWay: 1,
          //   accessFlag: 1,
          //   parentMenuId: '647390246509494273',
          //   sort: 1,
          //   status: null,
          //   extra: '',
          //   childList: []
          // }
        ]
      },
      // 教务中心 - 通知公告
      {
        menuId: '211551232122',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '通知公告',
        menuUrl: 'notice',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6473904sdasd6429999',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '通知公告',
            menuUrl: 'eduCenter_notice_eduIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 通知公告
      {
        menuId: '211551232123',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '师资管理',
        menuUrl: 'teachers',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '7473904sdasd6429991',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师师资库',
            menuUrl: 'eduCenter_teachers_index',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '211551232123',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      {
        menuId: '311551232983',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '平台服务',
        menuUrl: 'platform',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '647390546454399a1',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务协议管理',
            menuUrl: 'eduCenter_platform_agreementManage',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '64739054645439999',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务签约记录',
            menuUrl: 'eduCenter_platform_signing',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 基础信息中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '基础信息中心',
    menuUrl: 'basicInfoCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 基础信息中心 - 服务机构
      {
        menuId: 'asdjaaaskdja',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '服务机构',
        menuUrl: 'service',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: 'asdjaskdja',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务机构',
            menuUrl: 'resources_organ',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: 'asdjaskdjaa',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学期服务机构管理',
            menuUrl: 'semester_organ',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
          // {
          //   menuId: 'ddddd',
          //   domainCode: 'zhxy-cloud',
          //   appCode: 'basic430hon',
          //   typeCode: '$default',
          //   menuName: '机构教师',
          //   menuUrl: 'basicInfoCenter_schOrganService_teacher',
          //   menuIcon: '647390423244865536',
          //   openWay: 1,
          //   accessFlag: 1,
          //   parentMenuId: '647390246509494273',
          //   sort: 1,
          //   status: null,
          //   extra: '',
          //   childList: []
          // }
        ]
      }
    ]
  }
];
